import React, { useState, useEffect,Component  } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Logo from "../SmartEvacLogo.jpg";
import NewLogo from '../NewSmartEvacLogo.png';
import DisLogo from '../DisabledSmartEvac.png';
import { useNavigate } from 'react-router-dom';
import exportFromJSON from 'export-from-json'
import axios from 'axios';


const AWS = require('aws-sdk');

AWS.config.update({
  region: process.env.REACT_APP_AWS_REGION,
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY
});

const Main_params = {
  TableName: "Main_table"
};

const Dis_params = {
  TableName: "Other_table"
};


const apiURL = 'https://5sz631hba3.execute-api.eu-west-2.amazonaws.com/default/return-recognised-faces';

const getStatus_url = "https://33cio363k8.execute-api.eu-west-2.amazonaws.com/default/return_status";

function Start() {
  const [fetched_data, setfetched_data] = useState([]);
  const [fetched_disabled, setDisabled] = useState([]);
  const [data, setRecogn] = useState([]);
  const [evacstatus, setevacstatus] = useState('');
  const [colour, setColour] = useState('');

  const navigate = useNavigate();

  const fetchMainData = async () => {
    const dynamoDB = new AWS.DynamoDB.DocumentClient();
    dynamoDB.scan(Main_params, (err, result) => {
      if (err) {
        console.error('Error scanning the table',err);
      } else {
        console.log('Scan succeeded:', JSON.stringify(result, null, 2));
      }
    });
  };

  const fetchDisData = async () => {
    const dynamoDB = new AWS.DynamoDB.DocumentClient();
    dynamoDB.scan(Dis_params, (err, result) => {
      if (err) {
        console.error('Error scanning the table',err);
      } else {
        console.log('Scan succeeded:', JSON.stringify(result, null, 2));
        setDisabled(result.Items);
      }
    });
  };

  const fetchStatus = async () => {
    const response = await axios.get(getStatus_url);
    const parsedBody = JSON.parse(response.data.body);
    setevacstatus(parsedBody.status);
    if (parsedBody.status == "offline"){
      setColour("red");
    }
    if (parsedBody.status == "live"){
      setColour("green");
    }
  }

  const fetchRecognizedFaces = async () => {
    const removefielddata = {
      removefield: "false"
    }
    const response = await axios.put(apiURL,removefielddata);
    const parsedBody = JSON.parse(response.data.body);
    setfetched_data(parsedBody.NotRecognised);
    setRecogn(parsedBody.Recognised);
  }

  
  const EndEvacuation = async () => {
    console.log("Evac ended");
    console.log(data);
    const fileName = 'download';  
    const exportType = 'xls';
    try {
      exportFromJSON({ data: data.persons, fileName, exportType });
    } catch (error) {
        console.error("No faces were detected:", error);
    }
    navigate('/end', { state: { fetched_data } }); 
  }

  const checkPerson = (ID) => {
    console.log(ID);
    console.log(fetched_disabled.length);
  
    for (let i = 0; i < fetched_disabled.length; i++) {
      if (fetched_disabled[i].UserID == ID) {
        const updatedList = fetched_disabled.slice();
        updatedList.splice(i, 1);
        setDisabled(updatedList); 
        break; 
      }
    }
  };  

  useEffect(() => {
    fetchMainData();
    fetchDisData();
    const interval = setInterval(() => {
      fetchRecognizedFaces();
      fetchStatus();
    }, 2000);
    return () => clearInterval(interval);
  }, []);
  

  return (
    <Container className= "main-page-content">
      <Row className="justify-content-center">
      <h3>
        Evacuation status: <span style={{ color: colour }}>{evacstatus}</span>
      </h3>
      <h3>Count of persons yet to be detected:    {fetched_data.length}</h3>
        <Col xs={12} sm={10} md={8} lg={6}>
        <img className="napp-logo" src={NewLogo} width="200" height="160" alt="SmartEvac Logo" />
          <table className="table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Forename</th>
                <th>Surname</th>
              </tr>
            </thead>
            <tbody>
              {fetched_data.map((item, index) => (
                <tr key={index}>
                  <td>{item.UserID}</td>
                  <td>{item.fname}</td>
                  <td>{item.sname}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Col>
        <Col xs={12} sm={10} md={8} lg={6}>
          <img className="napp-logo" src={DisLogo} width="200" height="160" alt="SmartEvac Logo" />
          <table className="table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Forename</th>
                <th>Surname</th>
                <th>Check</th>
              </tr>
            </thead>
            <tbody>
              {fetched_disabled.map((item, index) => (
                <tr key={index}>
                  <td>{item.UserID}</td>
                  <td>{item.fname}</td>
                  <td>{item.sname}</td>
                  <button onClick={() => checkPerson(item.UserID)} type="submit" className="login-button">Check</button>
                </tr>
              ))}
            </tbody>
          </table>
        </Col>
        <button onClick={EndEvacuation} type="submit" className="login-button">End Evacuation</button>
      </Row>
    </Container>
  );
}

export default Start;
